import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=68cf4174&scoped=true&"
import script from "./forget.vue?vue&type=script&lang=js&"
export * from "./forget.vue?vue&type=script&lang=js&"
import style0 from "./forget.vue?vue&type=style&index=0&lang=css&"
import style1 from "./forget.vue?vue&type=style&index=1&id=68cf4174&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf4174",
  null
  
)

export default component.exports